import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useTranslation } from 'react-i18next';

const ExhibitorPanelHeader = styled.div<{$isOpened: boolean;}>`
  width: 100%;
  height: 48px;
  background-color: #2D3D49;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: ${({ $isOpened }) => (!$isOpened ? 'pointer' : 'initial')};
  font-weight: bold;
  border-bottom: 1px solid white;
`;

const ExhibitorPanelTitle = styled.div`
  color: white;
`;

const ExhibitorExpandMoreIcon = styled(AddIcon)<{$isOpened: boolean;}>`
  color: white;
  cursor: pointer;
  margin: 4px 0 4px 4px;
  transform: rotate(${({ $isOpened }) => ($isOpened ? 0 : 180)}deg);
`;

const ExhibitorCloseIcon = styled(RemoveIcon)<{$isOpened: boolean;}>`
  color: white;
  cursor: pointer;
  margin: 4px 0 4px 4px;
  transform: rotate(${({ $isOpened }) => ($isOpened ? 0 : 180)}deg);
`;

interface ExhibitorHeaderProps {
  isOpened: boolean
  setIsOpened: (isOpened) => void;
}

const ExhibitorHeader: FC<ExhibitorHeaderProps> = ({
  isOpened,
  setIsOpened,
}) => {
  const { t } = useTranslation();
  const expandButtonOnClick = useCallback((e) => {
    e.stopPropagation();
    setIsOpened(!isOpened);
  }, [isOpened, setIsOpened]);

  return (
    <ExhibitorPanelHeader
      onClick={() => { if (!isOpened) setIsOpened(true); }}
      $isOpened={isOpened}
    >
      <ExhibitorPanelTitle>
        {t('activity_log.exhibitor_panel', 'Exhibitor Dashboard')}
      </ExhibitorPanelTitle>
      {isOpened ? (
        <ExhibitorCloseIcon
          $isOpened={isOpened}
          onClick={(e) => expandButtonOnClick(e)}
        />
      ) : (
        <ExhibitorExpandMoreIcon
          $isOpened={isOpened}
          onClick={(e) => expandButtonOnClick(e)}
        />
      )}
    </ExhibitorPanelHeader>
  );
};

export default ExhibitorHeader;
